// extracted by mini-css-extract-plugin
var _1 = "ExchangeFormStyle-module__buy-content____lus4";
var _2 = "ExchangeFormStyle-module__buy-content____lus4";
var _3 = "ExchangeFormStyle-module__content-holder___Mbcac";
var _4 = "ExchangeFormStyle-module__content-holder___Mbcac";
var _5 = "ExchangeFormStyle-module__counter___eEM6r";
var _6 = "ExchangeFormStyle-module__receive-funds___UIPNK";
var _7 = "ExchangeFormStyle-module__receive-funds___UIPNK";
export { _1 as "buy-content", _2 as "buyContent", _3 as "content-holder", _4 as "contentHolder", _5 as "counter", _6 as "receive-funds", _7 as "receiveFunds" }
